import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>("faq-01");

  return (
    <section id="faq" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[360px_1fr] lg:gap-14">
          <div>
            <div className="mb-3 flex items-center gap-3">
              <span className="font-heading text-sm font-bold tracking-[0.3em] text-primary-600">FILE 05</span>
              <span className="h-px w-10 bg-primary-300" />
            </div>
            <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              常见问题
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              关于投稿、隐私与内容边界的疑问，基本都在这里。如果还有没说清的，欢迎直接给我们发邮件。
            </p>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-4">
              <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <i className="ri-mail-send-line text-primary-600" />
                直接联系我们
              </p>
              <a
                href="#contact"
                className="mt-2 block cursor-pointer text-sm text-primary-700 underline-offset-4 hover:underline"
              >
                前往底部投稿区留言
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => {
              const open = openId === faq.id;
              return (
                <Reveal key={faq.id} delay={index * 50}>
                  <div
                    className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                      open ? "border-primary-300" : "border-background-200"
                    }`}
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenId(open ? "" : faq.id)}
                        aria-expanded={open}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                      >
                        <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                          {faq.q}
                        </span>
                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg transition-colors ${
                            open
                              ? "bg-primary-600 text-background-50"
                              : "bg-background-100 text-foreground-600"
                          }`}
                        >
                          <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                        </span>
                      </button>
                    </h3>
                    {open ? (
                      <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                        {faq.a}
                      </p>
                    ) : null}
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}